define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../shared/dataLogs", "../import/import", "./phoneNumberActions", "./phoneNumberTester", "../../models/UserContext", "../../utils/kendoUtils"], function (require, exports, $, ko, log, urls_1, tools, DataLogs, Import, PhoneNumberActions, PhoneNumberTester, UserContext, KendoUtils) {
    "use strict";
    var PhoneNumbers = /** @class */ (function () {
        function PhoneNumbers() {
            this.userCanBulkEdit = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.BulkEdit"));
            this.userCanBulkDelete = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.BulkDelete"));
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete"));
            this.phoneActions = new PhoneNumberActions();
            this.canExport = UserContext.hasAccess("Admin,PhoneNumbers.Export");
            this.importModule = new Import();
            this.phoneTestModule = new PhoneNumberTester();
            this.filterByNumber = ko.observable("");
            this.filterByEntityName = ko.observable("");
            this.filterByProfider = ko.observable(0);
            this.filterByStatus = ko.observable(0);
            this.filterByNotAssigned = ko.observable(false);
            this.filterByCustomer = ko.observable("");
            this.filterByCustomerName = ko.observable("");
        }
        PhoneNumbers.prototype.init = function () {
            var self = this;
            $("#page-title").text("Phone Numbers");
            tools.ajaxGet({
                url: urls_1.urls.getPhoneGetLookupData,
                success: function (data) {
                    if (data.Success) {
                        self.phoneLookupLists = data.Data.lookupLists;
                        self.phoneLookupLists.officeLocations = ko.observableArray(data.Data.lookupLists.OfficeLocations);
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.phoneActions.removePhoneCallback = function () {
                        self.phoneNumbersTable.refresh();
                    };
                    self.phoneActions.savePhoneCallback = function () {
                        self.phoneNumbersTable.refresh();
                    };
                    self.phoneActions.init();
                    self.initKendoGrid(self.phoneLookupLists.GridStructures.PhoneNumbersStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        PhoneNumbers.prototype.filterPhoneByAnyOnChange = function (self, elm, e) {
            var inputNumber = elm.target.value;
            var containsPattern = /[a-zA-Z]/i;
            var patt = containsPattern.test(inputNumber) ? /[]/g : /[-+(). ]/g;
            if (patt.test(inputNumber)) {
                inputNumber = inputNumber.replace(patt, "");
                self.filterByNumber(inputNumber);
                self.phoneNumbersTable.refresh();
            }
        };
        PhoneNumbers.prototype.initTableFilter = function () {
            var self = this;
            function split(val) {
                return val.split(/,\s*/);
            }
            function extractLast(term) {
                return split(term).pop();
            }
            var selectedItems = [];
            function filterSelectedCustomers(term) {
                var filteredItems = ko.utils.arrayFilter(selectedItems, function (item) {
                    return term.indexOf(item.label) > -1;
                });
                var mappedData = ko.utils.arrayMap(filteredItems, function (item) { return item.value; });
                var customersList = ko.utils.arrayGetDistinctValues(mappedData).sort();
                log.log(customersList);
                self.filterByCustomer(customersList.join(","));
            }
            $("input[name=filterCustomer]").bind("keydown", function (event) {
                if (event.keyCode === $.ui.keyCode.TAB &&
                    $(this).autocomplete("instance").menu["active"]) {
                    event.preventDefault();
                }
            }).autocomplete({
                source: function (request, response) {
                    tools.ajaxPost({
                        url: "/Customers/findCustomerByName",
                        data: { Name: extractLast(request.term) },
                        success: function (Results) {
                            response($.map(Results.Data, function (item) { return ({
                                label: item.Name,
                                value: item.Id,
                                OfficeLocations: item.OfficeLocations
                            }); }));
                        }
                    });
                },
                select: function (event, ui) {
                    var terms = split(this.value);
                    // remove the current input
                    terms.pop();
                    // add the selected item
                    terms.push(ui.item.label);
                    selectedItems.push(ui.item);
                    // add placeholder to get the comma-and-space at the end
                    terms.push("");
                    this.value = terms.join(", ");
                    filterSelectedCustomers(this.value);
                    return false;
                },
                focus: function (event, ui) {
                    event.preventDefault();
                },
                open: function (event, ui) {
                    $(this).autocomplete("widget").css("z-index", 1060);
                    $(this).keydown(function (e) {
                        if (e.keyCode === 13) {
                            $(".ui-menu-item:first a").click();
                        }
                    });
                }
            });
            self.filterByProfider.subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByStatus.subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByNumber.extend({ rateLimit: 200 }).subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByEntityName.extend({ rateLimit: 200 }).subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByCustomer.subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByNotAssigned.subscribe(function () {
                self.phoneNumbersTable.refresh();
            });
            self.filterByCustomerName.subscribe(function () {
                if (!self.filterByCustomerName()) {
                    self.filterByCustomer(null);
                }
            });
        };
        PhoneNumbers.prototype.clearFilter = function () {
            var self = this;
            self.filterByNotAssigned(false);
            self.filterByNumber(null);
            self.filterByEntityName(null);
            self.filterByProfider(null);
            self.filterByStatus(null);
            self.filterByCustomer(null);
            self.filterByCustomerName(null);
        };
        PhoneNumbers.prototype.initKendoGrid = function (gridStructure) {
            var _this = this;
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "65px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete")) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if ((UserContext.hasAccess("Admin,PhoneNumbers.Delete,E911.Delete") && dataItem.CustomerId && !dataItem.HasE911)
                        || (UserContext.hasAccess("Admin,E911.Delete") && dataItem.CustomerId && dataItem.HasE911)) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.phoneNumbersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/PhoneNumbers/GetPhoneNumbers",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByNumber()) {
                                    data.number = self.filterByNumber();
                                }
                                if (self.filterByEntityName()) {
                                    data.entityName = self.filterByEntityName();
                                }
                                if (self.filterByCustomer()) {
                                    data.customerIds = self.filterByCustomer();
                                }
                                if (self.filterByProfider()) {
                                    data.providerId = self.filterByProfider();
                                }
                                if (self.filterByStatus()) {
                                    data.statusId = self.filterByStatus();
                                }
                                data.onlyNotAssigned = self.filterByNotAssigned();
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#number_toolbar-template").html()),
                    columns: columns,
                    autoBind: false,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    },
                },
                allowBulkEdits: {
                    enabled: true,
                    customDataAttributes: 'data-number="#=Number#" data-e911="#=HasE911#"'
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                enableExport: {
                    entityName: "PhoneNumber",
                    title: "Phone Numbers",
                    enablePdf: false
                },
                gridId: "tblPhoneNumberKendo",
                showPagerOnTop: false,
                controller: self
            };
            self.phoneNumbersTable.initGrid(gridOptions);
            $("#tblPhoneNumberKendo").on("reinit", function (e) {
                $("#tblPhoneNumberKendo tbody").on("click", ".btn-remove", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                    self.phoneActions.deleteNumberConfirm(dataItem.Id, dataItem.HasE911, dataItem.Number);
                    event.preventDefault();
                }).on("click", ".btn-edit", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                    self.phoneActions.editPhoneNumber(dataItem.Id, dataItem.Number, dataItem.CustomerId);
                    event.preventDefault();
                }).on("click", ".numberLogs", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                    var dataLogs = new DataLogs("PhoneNumber", dataItem.Id);
                    dataLogs.open("Phone number logs: " + dataItem.Number);
                    event.preventDefault();
                }).on("click", ".numberHistory", function (event) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                    var dataLogs = new DataLogs("PhoneNumber", dataItem.Id);
                    dataLogs.openPhoneNumberHistory(dataItem.Number, "Phone number logs: " + dataItem.Number);
                    event.preventDefault();
                });
                self.initTableFilter();
                $(".js-edit-phoneNumbers").on("click", function () {
                    _this.bulkEdit();
                    return false;
                });
                $(".js-delete-phoneNumbers").on("click", function () {
                    _this.bulkDelete();
                    return false;
                });
            });
            $("#tblPhoneNumberKendo").trigger("reinit");
        };
        PhoneNumbers.prototype.createNew = function () {
            var self = this;
            self.phoneActions.editPhoneNumber();
        };
        PhoneNumbers.prototype.bulkEdit = function () {
            var self = this;
            var listOfIds = [];
            $("#tblPhoneNumberKendo .check-row:checked").each(function () {
                listOfIds.push($(this).data());
            });
            if (listOfIds.length > 0 && listOfIds.length <= 1000) {
                self.phoneActions.bulkEditPhoneNumber(listOfIds);
            }
            else if (listOfIds.length > 1000) {
                tools.error("You can edit only 1000 number at a time");
            }
            else {
                tools.error("Please select at least one number to edit");
            }
        };
        PhoneNumbers.prototype.bulkDelete = function () {
            var self = this;
            var listOfIds = [];
            $("#tblPhoneNumberKendo .check-row:checked").each(function () {
                listOfIds.push($(this).data());
            });
            if (listOfIds.length > 0 && listOfIds.length <= 1000) {
                self.phoneActions.bulkDeletePhoneNumber(listOfIds);
            }
            else if (listOfIds.length > 1000) {
                tools.error("You can edit only 1000 number at a time");
            }
            else {
                tools.error("Please select at least one number to edit");
            }
        };
        PhoneNumbers.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.phoneNumbersTable.exportTo();
            }
        };
        PhoneNumbers.prototype.importPhoneNumbers = function () {
            var _this = this;
            var self = this;
            self.importModule.importPhoneNumbers(function () {
                _this.phoneNumbersTable.getGridData().dataSource.read();
            });
        };
        PhoneNumbers.prototype.testPhoneNumbers = function () {
            var self = this;
            self.phoneTestModule.openPhoneNumbersTester();
        };
        PhoneNumbers.prototype.updateEntityNamesConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Update Brekeke Entity Names",
                text: "Are you sure you want to Update Brekeke Entity Names?",
                buttonTitle: "Update",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updateEntityNames();
            });
        };
        PhoneNumbers.prototype.updateEntityNames = function () {
            var self = this;
            var btn1 = $("#updateEntityNames").button("loading");
            tools.ajaxGet({
                url: "/PhoneNumbers/UpdateBrekekeEntityNames",
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully. Total Updated: " + result.Data);
                    self.phoneNumbersTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        PhoneNumbers.prototype.updateBrandsConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Sync 10DLC Brands",
                text: "Are you sure you want to sync 10DLC Brands?",
                buttonTitle: "Sync",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updateBrands();
            });
        };
        PhoneNumbers.prototype.updateBrands = function () {
            var self = this;
            var btn1 = $("#updateBrands").button("loading");
            tools.ajaxGet({
                url: "/CampaignRegistry/SyncBrands",
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully. Total Updated: " + JSON.stringify(result.Data));
                    self.phoneNumbersTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        PhoneNumbers.prototype.updateCampaignsConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Sync 10DLC Campaigns",
                text: "Are you sure you want to sync 10DLC Campaigns?",
                buttonTitle: "Sync",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updateCampaigns();
            });
        };
        PhoneNumbers.prototype.updateCampaigns = function () {
            var self = this;
            var btn1 = $("#updateCampaigns").button("loading");
            tools.ajaxGet({
                url: "/CampaignRegistry/SyncCampaigns",
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully. Total Updated: " + JSON.stringify(result.Data));
                    self.phoneNumbersTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        PhoneNumbers.prototype.updateCampaignsStatusesConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Sync 10DLC Campaigns Statuses",
                text: "Are you sure you want to sync 10DLC Campaigns Statuses?",
                buttonTitle: "Sync",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updateCampaignsStatuses();
            });
        };
        PhoneNumbers.prototype.updateCampaignsStatuses = function () {
            var self = this;
            var btn1 = $("#updateCampaignsStatuses").button("loading");
            tools.ajaxGet({
                url: "/CampaignRegistry/SyncCampaignsStatus",
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully. Total Updated: " + JSON.stringify(result.Data));
                    self.phoneNumbersTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        PhoneNumbers.prototype.updatePhoneNumberCampaignsConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Sync Phone Numbers 10DLC Campaigns",
                text: "Are you sure you want to sync Phone Number 10DLC Campaigns?",
                buttonTitle: "Sync",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updatePhoneNumberCampaigns();
            });
        };
        PhoneNumbers.prototype.updatePhoneNumberCampaigns = function () {
            var self = this;
            var btn1 = $("#updatePhoneNumberCampaigns").button("loading");
            tools.ajaxGet({
                url: "/CampaignRegistry/SyncPhoneNumberCampaigns",
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully. Total Updated: " + JSON.stringify(result.Data));
                    self.phoneNumbersTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        PhoneNumbers.prototype.updatePendingPhoneNumberCampaignsConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Sync Pending Phone Numbers 10DLC Campaigns",
                text: "Are you sure you want to sync Pending Phone Number 10DLC Campaigns?",
                buttonTitle: "Sync",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updatePendingPhoneNumberCampaigns();
            });
        };
        PhoneNumbers.prototype.updatePendingPhoneNumberCampaigns = function () {
            var self = this;
            var btn1 = $("#updatePendingPhoneNumberCampaigns").button("loading");
            tools.ajaxGet({
                url: "/CampaignRegistry/SyncPendingPhoneNumberCampaigns",
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully. Total Updated: " + JSON.stringify(result.Data));
                    self.phoneNumbersTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        PhoneNumbers.prototype.updateCNAMsConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Update CNAM from Peerless",
                text: "Are you sure you want to Update CNAM from Peerless?",
                buttonTitle: "Update",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updateCNAMs();
            });
        };
        PhoneNumbers.prototype.updateCNAMs = function () {
            var self = this;
            var btn1 = $("#updateCNAMs").button("loading");
            tools.ajaxGet({
                url: "/AdminActions/SyncPeerlessCNAM",
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully.");
                    self.phoneNumbersTable.refresh();
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        PhoneNumbers.prototype.enableCNAMDeliveryConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Enable CNAM Delivery for Peerless",
                text: "Are you sure you want to Enable CNAM Delivery for Peerless?",
                buttonTitle: "Update",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updateCNAMDelivery(true);
            });
        };
        PhoneNumbers.prototype.disableCNAMDeliveryConfirm = function () {
            var _this = this;
            tools.confirmModal({
                title: "Disable CNAM Delivery for Peerless",
                text: "Are you sure you want to Disable CNAM Delivery for Peerless?",
                buttonTitle: "Update",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.updateCNAMDelivery(false);
            });
        };
        PhoneNumbers.prototype.updateCNAMDelivery = function (enableCNAMDelivery) {
            var self = this;
            var btn1 = $("#updateCNAMs").button("loading");
            tools.ajaxGet({
                url: "/PhoneNumbers/UpdatePeerlessCNAMDelivery?cnamDelivery=".concat(enableCNAMDelivery),
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully.");
                    self.phoneNumbersTable.refresh();
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        PhoneNumbers.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin,PhoneNumbers.Logs")) {
                var dataLogs = new DataLogs("PhoneNumber");
                dataLogs.open("Phone number logs");
            }
        };
        PhoneNumbers.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin,PhoneNumbers.Logs")) {
                var dataLogs = new DataLogs("PhoneNumber");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return PhoneNumbers;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/PhoneNumbers/Index")) {
            log.log("Initialize Phone numbers list");
            $(function () {
                (new PhoneNumbers()).init();
            });
        }
    }, 0);
    return PhoneNumbers;
});
//# sourceMappingURL=phoneNumbers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumbers/phoneNumbers.js
// module id = 208
// module chunks = 2